import React, { useState, useEffect } from "react";
import Button from 'react-bootstrap/Button';
import DataTable from 'react-data-table-component';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { getBankHolidaysAdmin, deleteBankHoliday } from "../../services/BankHolidaysService";
import Loader from "../common/Loader";

const BankHolidaysList = () => {

    const [bankHolidays, setBankHolidays] = useState([])
    const [activeTab, setActiveTab] = useState(0);
    const [pending, setPending] = useState(true);
    const [year, setYear] = useState(new Date().getFullYear());
    const tabYear = new Date().getFullYear();

    const showData = async (shownYear) => {
        const res = await getBankHolidaysAdmin(shownYear);
        let data = [];
        for (const key in res) {
            data.push({
                id: res[key].id,
                name: res[key].name,
                date: res[key].date
            })
        }
        setBankHolidays(data)
    }

    const handleTabChange = (index) => {
        setActiveTab(index);
        const newYear = new Date().getFullYear() + index;
        setYear(newYear);
      };

    useEffect(() => {
        (async () => {
          setPending(true);
          await showData(year);
          setPending(false);
        })();
    }, [year]);

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.name
        },
        {
            name: 'Fecha',
            selector: row => row.date
        },
        {
            name: '',
            button: true,
            cell: row => (
                <div>
                    <Button variant="outline-danger" onClick={() => deleteBankHolidayById(row.id)}>Eliminar</Button>
                </div>
            ),
        },
    ]

    return (
        <div className="container">
            <div className="row align-items-center my-5">
                <h1 className="font-weight-light">Lista de días festivos</h1>
                <Tabs selectedIndex={activeTab} onSelect={handleTabChange}>
                    <TabList>
                        <Tab>Festivos {tabYear}</Tab>
                        <Tab>Festivos {tabYear+1}</Tab>
                    </TabList>

                    <TabPanel>
                        <div className="App table">
                            <DataTable
                                columns={columns}
                                data={bankHolidays}
                                striped={true}
                                progressPending={pending}
                                progressComponent={<Loader />}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="App table">
                            <DataTable
                                columns={columns}
                                data={bankHolidays}
                                striped={true}
                                progressPending={pending}
                                progressComponent={<Loader />}
                            />
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
}

const deleteBankHolidayById = async (id) => {    
    await deleteBankHoliday(id);
    await window.location.reload();
}

export default BankHolidaysList;